import React, { useEffect, useState } from "react";
import "./FyersAccessToken.css";
import { environment } from "environment/environment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function FyersAccesstoken() {
    const [activeTab, setActiveTab] = useState("INDEX_API");
    const [indexApiFyersToken, setindexApiFyersToken] = useState([]);
    const [stockApiFyersToken, setstockApiFyersToken] = useState([]);
    const [loading, setLoading] = useState(false);

    /* ================= FETCH ON TAB CHANGE ================= */
    useEffect(() => {
        activeTab === "INDEX_API"
            ? fetchindexApiFyersToken()
            : fetchstockApiFyersToken();
    }, [activeTab]);

    /* ================= INDEX API ================= */
    const fetchindexApiFyersToken = async () => {
        setLoading(true);
        try {
            const res = await fetch(
                `${environment.baseUrl}/index-api-fyersone-login/get-all-index-api-fyers-token?apiName=INDEX_API`
            ).then(r => r.json());

            if (res.status) setindexApiFyersToken(res.data || []);
        } catch {
            toast.error("Failed to load Index API tokens");
        } finally {
            setLoading(false);
        }
    };

    const generateIndexToken = async () => {
        setLoading(true);
        try {
            const res = await fetch(
                `${environment.baseUrl}/index-api-fyersone-login/login`
            ).then(r => r.json());

            if (res.status) {
                toast.success("Index API token generated");
                fetchindexApiFyersToken();
            }
        } catch {
            toast.error("Index API generation failed");
        } finally {
            setLoading(false);
        }
    };

    /* ================= STOCK API ================= */
    const fetchstockApiFyersToken = async () => {
        setLoading(true);
        try {
            const res = await fetch(
                `${environment.stockApiBaseUrl}/stock-api-fyersone-login/get-all-stock-api-fyers-token?apiName=STOCK_API`
            ).then(r => r.json());

            if (res.status) setstockApiFyersToken(res.data || []);
        } catch {
            toast.error("Failed to load Stock API tokens");
        } finally {
            setLoading(false);
        }
    };

    const generateStockToken = async () => {
        setLoading(true);
        try {
            const res = await fetch(
                `${environment.stockApiBaseUrl}/stock-api-fyersone-login/login`
            ).then(r => r.json());

            if (res.status) {
                toast.success("Stock API token generated");
                fetchstockApiFyersToken();
            }
        } catch {
            toast.error("Stock API generation failed");
        } finally {
            setLoading(false);
        }
    };

    /* ================= TABLE ================= */
    const renderTable = (data) => (
        <table className="responsive-table table-bordered text-center sticky-header full-height-table">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>DATE</th>
                    <th>TIME</th>
                    <th>GENERATED BY</th>
                    <th>API NAME</th>
                    <th>FYERS ACCESS TOKEN</th>
                </tr>
            </thead>
            <tbody>
                {data.length ? (
                    data.map((row, i) => (
                        <tr key={i}>
                            <td>{row.id ?? "--"}</td>
                            <td>{row.createdDate ?? "--"}</td>
                            <td>{row.createdTime ?? "--"}</td>
                            <td>{row.generatedBy ?? "--"}</td>
                            <td>{row.apiName ?? "--"}</td>
                            <td>
                                <span className="token-box">
                                    {row.fyersAccessToken ?? "--"}
                                </span>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="6">No data available</td>
                    </tr>
                )}
            </tbody>
        </table>
    );

    return (
        <div className="fyers-access-token-page full-page">
            <ToastContainer position="top-center" />

            {/* ===== HEADER (UNCHANGED) ===== */}
            <header className="header">
                <nav className="nav-container">
                    <div className="logo-container">
                        <img
                            src="/assets/images/noptionwave-logo-1.png"
                            className="header-logo"
                            alt="noptionwave logo"
                        />
                    </div>
                </nav>
            </header>

            {/* ===== TABS ===== */}
            <div className="tab full-width-tabs">
                <button
                    className={`tablinks ${activeTab === "INDEX_API" ? "active" : ""}`}
                    onClick={() => setActiveTab("INDEX_API")}
                >
                    Index API
                </button>

                <button
                    className={`tablinks ${activeTab === "STOCK_API" ? "active" : ""}`}
                    onClick={() => setActiveTab("STOCK_API")}
                >
                    Stock API
                </button>
            </div>

            {/* ===== CONTENT (ONLY ONE RENDERS) ===== */}
            <div className="tabcontent full-page-content">
                <div className="table-action-bar">
                    <h3 className="page-title">
                        {activeTab === "INDEX_API"
                            ? "Index API – Fyers Access Tokens"
                            : "Stock API – Fyers Access Tokens"}
                    </h3>

                    <button
                        className="generate-token-btn"
                        onClick={
                            activeTab === "INDEX_API"
                                ? generateIndexToken
                                : generateStockToken
                        }
                        disabled={loading}
                    >
                        {loading ? "Generating..." : "Generate Token"}
                    </button>
                </div>

                <div className="table-container full-page-table">
                    {activeTab === "INDEX_API"
                        ? renderTable(indexApiFyersToken)
                        : renderTable(stockApiFyersToken)}
                </div>
            </div>
        </div>
    );
}
